<template>
	<div>
		<v-menu v-model="menuOpen" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					:label="label"
					:value="tempText !== null ? tempText : localeDate"
					:readonly="textFieldReadOnly"
					@input="setTempInput"
					@keydown.tab="menuOpen = false"
					:rules="validationRules"
					:error="tempText !== null && tempText.length >= (format ? format : $t('$global.date.normal')).length"
					append-icon="mdi-calendar"
					v-bind="{ ...attrs, ...$attrs }"
					v-on="{ ...on, ...$listeners }"
					dense
					outlined
				></v-text-field>
			</template>
			<v-date-picker
				v-model="computedDateString"
				:min="min"
				:max="max"
				@input="menuOpen = false"
				:first-day-of-week="1"
				locale="de-AT"
			></v-date-picker>
		</v-menu>
	</div>
</template>
<script>
import i18n from './dictionary';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export default {
	name: 'DatePicker',
	i18n,
	props: {
		dayjsObject: {
			type: Object,
			required: false,
			validator(value) {
				if (value instanceof dayjs) return true;
				else return `Prop "dayjsObject" must be an instanceof "dayjs".`;
			},
		},
		dateObject: {
			type: Date,
			required: false,
		},
		dateString: {
			type: String,
			required: false,
		},
		purgeTime: {
			type: Boolean,
			default: true,
		},
		label: String,
		textFieldReadOnly: {
			type: Boolean,
			default: false,
		},
		format: {
			type: String,
			required: false,
		},
		min: {
			type: String,
			required: false,
		},
		max: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			menuOpen: false,
			tempText: null,
		};
	},
	computed: {
		validationRules() {
			return [this.tempText === null || this.$t('dateInvalid')];
		},
		computedDateString: {
			get() {
				if (this.dayjsObject) return this.dayjsObject.format('YYYY-MM-DD');
				else if (this.dateObject) return dayjs(this.dateObject).format('YYYY-MM-DD');
				else return this.dateString;
			},
			set(value) {
				let dayjsObject = dayjs(value, 'YYYY-MM-DD', true);
				if (this.purgeTime) {
					dayjsObject = dayjsObject.hour(0);
					dayjsObject = dayjsObject.minute(0);
					dayjsObject = dayjsObject.second(0);
					dayjsObject = dayjsObject.millisecond(0);
				} else if (this.purgeTime === false) {
					dayjsObject = dayjsObject.endOf('day');
					// console.log(dayjsObject);
				}
				if (dayjsObject.isValid()) {
					this.tempText = null;
					this.$emit('update:dateObject', dayjsObject.toDate());
					this.$emit('update:dayjsObject', dayjsObject);
					this.$emit('update:dateString', dayjsObject.format('YYYY-MM-DD'));
				} else {
					this.$emit('update:dateObject', undefined);
					this.$emit('update:dayjsObject', undefined);
					this.$emit('update:dateString', '');
				}
			},
		},
		localeDate() {
			const desiredFormat = this.format ? this.format : this.$t('$global.date.normal');
			const localeDate = dayjs(this.computedDateString, 'YYYY-MM-DD', true);
			if (localeDate.isValid()) return localeDate.format(desiredFormat);
			else return '';
		},
	},
	methods: {
		setTempInput(value) {
			const lastChar = value.slice(-1);
			if (lastChar === '.') value = value.slice(0, -1);
			else if ((value.length === 3 || value.length === 6) && lastChar !== '.')
				value = value.substr(0, value.length - 1) + '.' + lastChar;
			else if (value.length === 2 || value.length === 5) value += '.';

			this.tempText = value;
			const tempDate = dayjs(value, this.format ? this.format : this.$t('$global.date.normal'), true);
			if (tempDate.isValid()) this.computedDateString = tempDate.format('YYYY-MM-DD');
		},
	},
	mounted() {
		if (this.computedDateString) {
			let dayjsObject = dayjs(this.computedDateString);
			if (this.purgeTime) {
				dayjsObject = dayjsObject.hour(0);
				dayjsObject = dayjsObject.minute(0);
				dayjsObject = dayjsObject.second(0);
				dayjsObject = dayjsObject.millisecond(0);
			}
			if (dayjsObject.isValid()) {
				this.tempText = null;
				this.$emit('update:dateObject', dayjsObject.toDate());
				this.$emit('update:dayjsObject', dayjsObject);
				this.$emit('update:dateString', dayjsObject.format('YYYY-MM-DD'));
			} else {
				// this.tempText = '';
				this.$emit('update:dateObject', undefined);
				this.$emit('update:dayjsObject', undefined);
				this.$emit('update:dateString', '');
			}
		}
	},
};
</script>
